<template>
  <div id="main-content" class="send-notification-page">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form v-if="masterData">
        <el-row style="padding-top: 30px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.title') }}</span>
            </el-col>
            <el-col :span="12">
              <input style="float: left !important; width: 100%" class="input" v-model="notification_data.title" type=""/>
            </el-col>
            <el-col :span="4">
              <el-button @click="dialogFormVisible = true" style="float: right; margin-left: 20px" type="success">
                {{ $t('common.template') }}
              </el-button>
            </el-col>
            <el-col v-if="error_message.title" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.title" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :offset="1" :span="11" style="display: inline">
            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('notification.send_type') }}</span></el-col>
            <select style="" class="input" v-model="notification_data.send_type">
              <option value="">{{ $t('common.please_select') }}</option>
              <option :value="SEND_NOTIFICATION_ONLY_PUSH">{{ $t('notification.push_notification') }}</option>
              <option :value="SEND_NOTIFICATION_ONLY_EMAIL">{{ $t('common.email') }}</option>
              <option :value="SEND_NOTIFICATION_BOTH">{{ $t('common.both') }}</option>
            </select>
            <el-col v-if="error_message.send_type" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.send_type" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 30px">
          <el-col :span="24" style="display: inline">
            <el-col :span="4"><span class="required-star">* </span><span class="form-lable" style="width: 20%;margin-right: 7px !important;">{{ $t('common.content') }}</span>
            </el-col>
            <b-form-textarea
              id="textarea"
              style="float: left !important;"
              v-model="notification_data.content"
              placeholder=""
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <el-col v-if="error_message.content" :offset="4" :span="16">
              <span v-for="(value, key) in error_message.content" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>

        <div class="target-group">
          <div class="row-section target-group__header">
            <h3>{{ $t('common.parent') }}</h3>
            <div class="target-group__all">
              <el-checkbox v-model="isAllParent">{{ $t('common.all') }}</el-checkbox>
            </div>
          </div>

          <div class="target-group__body" v-show="!isAllParent">
            <el-row>
              <el-col :span="24" style="display: inline">
                <el-col :span="4">
                  <span class="form-lable" style="width: 100%">{{ $t('notification.parent_group') }}</span>
                </el-col>
                <el-col :span="20">
                  <multiselect
                          v-model="selectedParentGroup"
                          :options="parentGroupList"
                          :multiple="true"
                          track-by="id"
                          :custom-label="customLabelGroup"
                          :placeholder="$t('common.please_select')">
                  </multiselect>
                </el-col>
              </el-col>
            </el-row>

            <el-row style="padding-top: 30px">
              <el-col :span="24" style="display: inline">
                <el-col :span="4">
                  <span class="form-lable" style="width: 100%">{{ $t('common.parent') }}</span>
                </el-col>
                <el-col :span="20">
                  <multiselect
                          v-model="selectedParent"
                          :options="parentList"
                          :multiple="true"
                          track-by="id"
                          :custom-label="customParentLabel"
                          :placeholder="$t('common.please_select')">
                  </multiselect>
                </el-col>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="target-group">
          <div class="row-section target-group__header">
            <h3>{{ $t('common.sub_driver') }}</h3>
            <div class="target-group__all">
              <el-checkbox v-model="isAllSubDriver">{{ $t('common.all') }}</el-checkbox>
            </div>
          </div>

          <div class="target-group__body" v-show="!isAllSubDriver">
            <el-row>
              <el-col :span="24" style="display: inline">
                <el-col :span="4">
                  <span class="form-lable" style="width: 100%">{{ $t('notification.sub_driver_group') }}</span>
                </el-col>
                <el-col :span="20">
                  <multiselect
                          v-model="selectedSubGroup"
                          :options="subGroupList"
                          :multiple="true"
                          track-by="id"
                          :custom-label="customLabelGroup"
                          :placeholder="$t('common.please_select')">
                  </multiselect>
                </el-col>
              </el-col>
            </el-row>

            <el-row style="padding-top: 30px">
              <el-col :span="24" style="display: inline">
                <el-col :span="4">
                  <span class="form-lable" style="width: 100%">{{ $t('common.sub_driver') }}</span>
                </el-col>
                <el-col :span="20">
                  <multiselect
                          v-model="selectedSub"
                          :options="subDriverList"
                          :multiple="true"
                          track-by="id"
                          :custom-label="customLabel"
                          :placeholder="$t('common.please_select')">
                  </multiselect>
                </el-col>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>

    <el-dialog :title="$t('common.select_template')" :visible.sync="dialogFormVisible">
      <el-form>
        <el-row>
          <el-col :span="8"><span class="form-lable">{{ $t('common.template') }}</span></el-col>
          <select style="" class="input" v-model="templateId">
            <option value="">{{ $t('common.please_select') }}</option>
            <option v-for="item in adminNotificationTemplateList" v-bind:key="item.id" :value="item.id">
              {{ item.title }}
            </option>
          </select>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="didSelectTemplate">{{ $t('common.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import Multiselect from 'vue-multiselect'
  import {
    USER_TYPE_PARENT,
    USER_TYPE_SUB_DRIVER,
    SEND_NOTIFICATION_ONLY_PUSH,
    SEND_NOTIFICATION_ONLY_EMAIL,
    SEND_NOTIFICATION_BOTH
  } from '@/config'
  import { basicSort } from '@/utils'

  export default {
    name: "AddAdminNotification",
    components: {
      PageTitle,
      Multiselect
    },
    data: function () {
      return {
        backLink: ``,
        title: 'menu.send_notification',
        notification_data: {
          title: "",
          send_type: "",
          content: "",
          parent_ids: "",
          sub_driver_ids: "",
        },
        selectedParent: [],
        selectedSub: [],
        selectedSubGroup: [],
        selectedParentGroup: [],
        subGroupList: [],
        parentGroupList: [],
        dialogFormVisible: false,
        error_message: {
          title: [],
          send_type: [],
          content: []
        },
        templateId: "",
        parentList: [],
        adminNotificationTemplateList: [],
        masterData: null,
        SEND_NOTIFICATION_ONLY_PUSH,
        SEND_NOTIFICATION_ONLY_EMAIL,
        SEND_NOTIFICATION_BOTH,
        isAllParent: false,
        isAllSubDriver: false
      }
    },
    methods: {
      didSelectTemplate: function () {
        this.dialogFormVisible = false
        this.notification_data.title = this.adminNotificationTemplateList[this.adminNotificationTemplateList.findIndex(x => x.id == this.templateId)].title
        this.notification_data.content = this.adminNotificationTemplateList[this.adminNotificationTemplateList.findIndex(x => x.id == this.templateId)].content
      },
      setData: function () {
        let parentIds = []

        if (this.selectedParentGroup.length) {
          this.selectedParentGroup.forEach((group) => {
            let memberIds = group.member_ids.split(',')

            memberIds.forEach((memberId) => {
              if (parentIds.indexOf(memberId) === -1) {
                parentIds.push(memberId)
              }
            })
          })
        }

        if (this.selectedParent.length) {
          this.selectedParent.forEach((parent) => {
            if (parentIds.indexOf(parent.id) === -1) {
              parentIds.push(parent.id)
            }
          })
        }

        let subDriverIds = []

        if (this.selectedSubGroup.length) {
          this.selectedSubGroup.forEach((group) => {
            let memberIds = group.member_ids.split(',')

            memberIds.forEach((memberId) => {
              if (subDriverIds.indexOf(memberId) === -1) {
                subDriverIds.push(memberId)
              }
            })
          })
        }
        if (this.selectedSub.length) {
          this.selectedSub.forEach((subDriver) => {
            if (subDriverIds.indexOf(subDriver.id) === -1) {
              subDriverIds.push(subDriver.id)
            }
          })
        }

        this.notification_data.parent_ids = parentIds
        this.notification_data.sub_driver_ids = subDriverIds
      },
      submitAction: function () {
        this.setData()
        let check = this.validate()

        if (check) {
          let successCallback = () => {
            this.$store.commit('openNotification', {
              type: 'success',
              message: this.$t('notification.send_notification_success')
            })
            this.$router.push('/admin-notification')
          }

          if (this.isAllParent) {
            this.notification_data.parent_ids = -1
          }

          if (this.isAllSubDriver) {
            this.notification_data.sub_driver_ids = -1
          }

          let payload = {
            successCallback,
            data: this.notification_data
          }
          this.$store.dispatch('notification/createNotification', payload);
        }
      },
      validate: function () {
        let check = true
        let message = this.$t('common.please_check_input_error')

        this.error_message.title = []
        if (this.notification_data.title === "") {
          this.error_message.title.push('* ' + this.$t('common.title_is_required'))
          check = false
        }

        this.error_message.send_type = []
        if (this.notification_data.send_type === '') {
          check = false
          this.error_message.send_type.push('* ' + this.$t('notification.send_type_is_required'))
        }

        this.error_message.content = []
        if (this.notification_data.content === '') {
          check = false
          this.error_message.content.push('* ' + this.$t('common.content_is_required'))
        }

        if (!this.notification_data.sub_driver_ids.length &&
            !this.notification_data.parent_ids.length &&
            !this.isAllParent &&
            !this.isAllSubDriver) {
          check = false
          message = this.$t('common.please_choose_least_one_account')
        } else if (!this.isAllParent) {
          let originalParentIds = []

          this.notification_data.parent_ids.forEach((parentId) => {
            parentId = parentId.toString().split('_')

            if (parentId.length === 1) {
              originalParentIds.push(parentId[0])
            }
          })

          if (!originalParentIds.length && this.notification_data.send_type === SEND_NOTIFICATION_ONLY_PUSH) {
            check = false
            message = this.$t('common.selected_accounts_only_send_mail')
          }
        }

        if (!check) {
          this.$store.commit('openNotification', {
            type: 'error',
            message
          })
        }

        return check
      },
      customLabel(option) {
        return `${option.name} - ${option.email}`
      },
      customParentLabel (item) {
        let id = item.id.toString().split('_')
        let label = `${item.name}`

        if (item.email) {
          label += ` - ${item.email}`
        }

        if (id.length > 1) {
          label += ` (${this.$t('common.partner')})`
        }

        return label
      },
      customLabelGroup(option) {
        return `${option.name}`
      }
    },
    mounted: function () {
      let payload = {
        successCallback: (response) => {
          this.masterData = Object.assign({}, response.data.data)
        }
      }

      this.$store.dispatch('adminnotification/retrieveAdminNotificationMasterData', payload)
    },
    computed: {

    },
    watch: {
      masterData: {
        deep: true,
        handler: function (masterData) {
          this.adminNotificationTemplateList = [].concat(masterData.template_list)

          masterData.group_list.forEach((item) => {
            if (item.type === USER_TYPE_PARENT) {
              this.parentGroupList.push(item)
            } else if (item.type === USER_TYPE_SUB_DRIVER) {
              this.subGroupList.push(item)
            }
          })

          this.parentList = [].concat(masterData.parent_list)
          this.subDriverList = [].concat(masterData.sub_driver_list)

          this.adminNotificationTemplateList.sort((before, after) => basicSort(before, after, 'title'))
          this.parentGroupList.sort((before, after) => basicSort(before, after, 'name'))
          this.subDriverList.sort((before, after) => basicSort(before, after, 'name'))
          this.parentList.sort((before, after) => basicSort(before, after, 'name'))
          this.subDriverList.sort((before, after) => basicSort(before, after, 'name'))
        }
      }
    }
  }
</script>

<style lang="scss">
  .send-notification-page {
    .target-group {
      margin-top: 50px;
      $group: &;

      &__header {
        position: relative;

        .target-group__all {
          position: absolute;
          right: 0;
          top: 10px;
        }
      }
    }
  }
</style>
